import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getWebUserByEmail } from "../api/webUserAPI";
import { getCurrentTenant } from "../config/tenantConfig";
import { getTenantMenuConfig } from "../config/menuConfig";

const MenuContent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [userRoles, setUserRoles] = React.useState([]);
  const [menuItems, setMenuItems] = React.useState([]);
  const hasCheckedRoles = React.useRef(false);

  React.useEffect(() => {
    if (hasCheckedRoles.current) return;

    const checkUserRoles = async () => {
      try {
        const userName = localStorage.getItem("userName");
        if (userName) {
          const userData = await getWebUserByEmail(userName);
          if (userData?.roles && Array.isArray(userData.roles)) {
            setUserRoles(userData.roles);
          } else {
            setUserRoles([]);
          }
        }
        hasCheckedRoles.current = true;
      } catch (error) {
        console.error("Error checking user roles:", error);
        setUserRoles([]);
        hasCheckedRoles.current = true;
      }
    };

    checkUserRoles();
  }, []);

  React.useEffect(() => {
    // Current tenant'ı al
    const currentTenant = getCurrentTenant();
    const projectCode = currentTenant?.projectCode || "DEFAULT";
    
    // Tenant'a göre menu config'ini al
    let tenantMenuItems = getTenantMenuConfig(projectCode);
    

    
    setMenuItems(tenantMenuItems);
  }, []);

  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: "space-between" }}>
      <List dense>
        {menuItems.map((item, index) => (
          <ListItem
            key={index}
            disablePadding
            sx={{ display: "block", mb: 1.5 }}
          >
            <ListItemButton
              selected={location.pathname === item.path}
              onClick={() => navigate(item.path)}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText
                primary={<span style={{ fontSize: "1rem" }}>{t(item.text)}</span>}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
};

export default MenuContent;